import React from 'react';
import image from '../../assets/images/notFound.jpg';

const NotFound = () => {
    return (
        <div className='flex justify-center items-center h-[100vh]'>
            <img src={image} alt="" />
        </div>
    );
};

export default NotFound;